import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import strings from "translate/language";
import { isEmpty, seo } from "utils/utils";
import {
  getAppointmentDetail,
  editAppointment,
} from "../../reduxStore/action/appointmentActions";
import TimePicker from "react-time-picker";
import Breadcrumb from "component/common/breadcrumb";
import { handleDetailResponse } from "../../utils/utils";
import { AutocompletePlace } from "component/common/PlacesAutocomplete";
import {
  SupportRequest,
  ClosingManager,
  closing_head_id,
  ClosingTL,
  SourcingManager,
  SourcingTL,
  sourcing_head_id,
  SCM,
  SiteHead,
  BusinessHead,
  // AdminRoleId,
  // PostSale,
  // Receptionist,
  ClusterHead,
  admin_id,
  SourcingHead,
} from "../../utils/constants";

const EditAppointment = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formVaild, setFormVaild] = useState(null);
  const [form, setForm] = useState({});
  const appointmentDetailSelector = useSelector((state) => state.appointment);
  const navigatpage = async (navname) => {
    navigate(navname);
  };

  const params = useParams();
  const { _id = "" } = params;
  const { response: res } = useSelector((state) => state.login);

  const role_id = res?.data?.role_id;
    const Cmteam =
      ClosingTL === role_id ||
      ClosingManager === role_id ||
      closing_head_id === role_id;
  
    const SMteam =
      SourcingTL === role_id ||
      SourcingManager === role_id ||
      sourcing_head_id === role_id;
  
    const mixTeam =
      SCM === role_id ||
      SiteHead === role_id ||
      ClusterHead === role_id ||
      BusinessHead === role_id ||
      admin_id === role_id;

  useEffect(() => {
    if (appointmentDetailSelector.detail === true) {
      const { response } = appointmentDetailSelector;
      if (response?.status === 200) {
        setForm({
          ...form,
          _id: handleDetailResponse(response?.data)._id,
          customer_first_name: handleDetailResponse(response?.data)
            .customer_first_name,
          pickup_location: handleDetailResponse(response?.data).pickup_location,
          pickup_latitude: handleDetailResponse(response?.data).pickup_latitude,
          pickup_longitude: handleDetailResponse(response?.data)
            .pickup_longitude,
          pickup_address: handleDetailResponse(response?.data).pickup_address,
          number_of_guest: handleDetailResponse(response?.data).number_of_guest,
          property_title: handleDetailResponse(response?.data)?.property_title,
          pickup: handleDetailResponse(response?.data).pickup,
          appointment_time:
            handleDetailResponse(response?.data).appointment_time ===
              "Invalid date"
              ? moment().format("hh:mm a")
              : handleDetailResponse(response?.data).appointment_time,
          appointment_date: moment(
            handleDetailResponse(response?.data)?.appointment_date
          ).format("yyyy-MM-DD"),
        });
      }
    } else {
      if (appointmentDetailSelector.create === true) {
        if (appointmentDetailSelector?.response?.status === 200) {
          setForm({});
          if(SMteam){
            navigatpage("/appointment_site_visit");
          }else{
            navigatpage("/appointment");
          }
          
        }
      }
    }
  }, [appointmentDetailSelector]);

  useEffect(() => {
    dispatch(getAppointmentDetail({ appointment_id: _id }));
  }, [_id]);

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };
  const handleInputTime = (appointment_time) => {
    let formErr = { ...formVaild };
    if (appointment_time===""||appointment_time===undefined) {
 
      formErr["appointment_time"] = strings.ValidTimeErr;
    }
    setFormVaild(formErr);
  };

  const handleInputArea = (e) => {
    const nextFormState = {
      ...form,
      pickup_location: e,
      pickup_latitude: "",
      pickup_longitude: "",
    };
    setForm(nextFormState);
  };
  const onSelect = (latLng, pickup_location) => {
    const nextFormState = {
      ...form,
      pickup_location: pickup_location,
      pickup_latitude: latLng.lat,
      pickup_longitude: latLng.lng,
    };
    setForm(nextFormState);
  };

  const handleEdit = () => {
    if (!handleValid()) {
      const post = {
        lead_id: form.lead_id,
        appointment_id: form._id,
        // pickup: form.pickup,
        // pickup_location: form.pickup_location,
        // pickup_latitude: form.pickup_latitude,
        // pickup_longitude: form.pickup_longitude,
        // pickup_address: form.pickup_address,
        appointment_time: form.appointment_time,
        appointment_date: moment(form.appointment_date).format("yyyy-MM-DD"),
        remark:form.remark
      };
      dispatch(editAppointment(post));
    }
  };
  const handleValid = () => {
    let err = {};
    let formError = false;
    if (!form.appointment_date) {
      formError = true;
      err["appointment_date"] = strings.followup_dateErr;
    }
    if (!form.appointment_time) {
      formError = true;
      err["appointment_time"] = strings.followup_timeErr;
    }
    // if (form.pickup === "Yes") {
    //   if (!form.pickup_location) {
    //     formError = true;
    //     err["pickup_location"] = strings.pickupLocationErr;
    //   }
    //   if (!form.pickup_address) {
    //     formError = true;
    //     err["pickup_address"] = strings.addressErr;
    //   }
    //   if (!form.number_of_guest) {
    //     formError = true;
    //     err["number_of_guest"] = strings.numberOfGuest;
    //   } else if (isNaN(form.number_of_guest)) {
    //     formError = true;
    //     err["number_of_guest"] = strings.validNumber;
    //   }
    // }
    setFormVaild(err);
    return formError;
  };
  useEffect(() => {
    seo({
      title: "Edit Appointment",
      metaDescription: "Edit appointment details",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.editAppointment}
        url={"/appointment"}
        parentListing={strings.appointmentList}
        titleactive={strings.EditAppointment}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.editAppointment}</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-8">
                    <div className="form-group">
                      <label htmlFor="exampleFormControlSelect9">
                        {strings.property}
                      </label>
                      <input
                        className="form-control"
                        id="exampleFormControlFirstName"
                        autoComplete="off"
                        name="property_title"
                        type="text"
                        value={form.property_title}
                        onChange={handleInputField}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-8">
                    <div className="form-group">
                      <label htmlFor="exampleFormControlSelect9">
                        {strings.lead}
                      </label>
                      <input
                        className="form-control"
                        id="exampleFormControlFirstName"
                        autoComplete="off"
                        name="customer_first_name"
                        type="text"
                        value={form.customer_first_name}
                        onChange={handleInputField}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="row ">
                  <div className="col-md-4 ">
                    <div className="form-group">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.AppointmentDate}
                        <span className="required-field"></span>
                      </label>
                      <input
                        className="form-control"
                        id="exampleFormControlFirstName"
                        name="appointment_date"
                        type="Date"
                        value={form?.appointment_date}
                        onChange={handleInputField}
                      />
                      {formVaild?.appointment_date && (
                        <span style={{ color: "red" }}>
                          {formVaild?.appointment_date}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4 ">
                    <div className="form-group">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.AppointmentTime}
                        <i
                          className="fa fa-info-circle pl-1 pr-1"
                          title={strings.AppointmentTimeDetail}
                          aria-hidden="true"
                          style={{ cursor: "pointer" }}
                        ></i>
                        <span className="required-field"></span>
                      </label>

                      <TimePicker
                        onChange={handleInputTime}
                        value={form?.appointment_time}
                        clockIcon={null}
                        clearIcon={null}
                        disableClock={true}
                        format={"hh:mm a"}
                        className="form-control"
                        name="appointment_time"
                      />
                      {formVaild?.appointment_time && (
                        <span style={{ color: "red" }}>
                          {formVaild?.appointment_time}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                {/* <div className="row">
                  <div className="col-md-8">
                    <div className="form-group">
                      <label htmlFor="exampleFormControlLastName">
                        {strings.pickup}
                      </label>
                      <div className="col">
                        <div className="form-group m-t-15 m-checkbox-inline mb-0 custom-radio-ml">
                          <div className="radio radio-primary mr-5">
                            <input
                              id="radioinline4"
                              type="radio"
                              name="pickup"
                              value={"Yes"}
                              checked={form.pickup === "Yes" ? true : false}
                              onChange={handleInputField}
                            />
                            <label className="mb-0" htmlFor="radioinline4">
                              {strings.yes}
                            </label>
                          </div>
                          <div className="radio radio-primary mr-5 ml-5">
                            <input
                              id="radioinline5"
                              type="radio"
                              name="pickup"
                              value={"No"}
                              checked={form.pickup === "No" ? true : false}
                              onChange={handleInputField}
                            />
                            <label className="mb-0" htmlFor="radioinline5">
                              {strings.no}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {form.pickup === "Yes" ? (
                  <>
                    <div className="row">
                      <div className="col-md-8">
                        <div className="mb-3">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.pickuplocation}
                            <span className="required-field"></span>
                          </label>
                          <AutocompletePlace
                            placeholder={strings.pickuplocation}
                            value={form.pickup_location}
                            onChange={handleInputArea}
                            onSelect={onSelect}
                            name="pickup_location"
                          />
                          {formVaild?.pickup_location && (
                            <span style={{ color: "red" }}>
                              {formVaild?.pickup_location}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-md-8 ">
                        <div className="form-group">
                          <label htmlFor="exampleFormControlFirstName">
                            {strings.address}
                            <span className="required-field"></span>
                          </label>
                          <input
                            className="form-control"
                            id="exampleFormControlFirstName"
                            autoComplete="off"
                            type="text"
                            name="pickup_address"
                            value={form.pickup_address}
                            onChange={handleInputField}
                            placeholder={strings.address}
                          />
                          {formVaild?.pickup_address && (
                            <span style={{ color: "red" }}>
                              {formVaild?.pickup_address}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-md-8 ">
                        <div className="form-group">
                          <label htmlFor="exampleFormControlFirstName">
                            {strings.numberofGuest}
                            <span className="required-field"></span>
                          </label>
                          <input
                            className="form-control"
                            id="exampleFormControlFirstName"
                            autoComplete="off"
                            type="number"
                            name="number_of_guest"
                            value={form.number_of_guest}
                            onChange={handleInputField}
                            placeholder={strings.numberofGuest}
                            onKeyPress={(e) => {
                              if (e.target.value.length >= 2) {
                                e.preventDefault();
                              }
                            }}
                          />
                          {formVaild?.number_of_guest && (
                            <span style={{ color: "red" }}>
                              {formVaild?.number_of_guest}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                ) : null} */}

<div className="row">
  <div className="col-md-8">
    <div className="form-group">
      <label htmlFor="commentSection">
        {strings.comment} {/* Ensure the proper string for "Comment" */}
      </label>
      <textarea
        className="form-control"
        id="commentSection"
        name="comment"
        rows="4" 
        value={form?.remark}
        onChange={handleInputField} 
      ></textarea>
      {formVaild?.remarks && (
        <span style={{ color: "red" }}>
          {formVaild?.remarks}
        </span>
      )}
    </div>
  </div>
</div>
                <div className="row">
                  <div className="col-md-12 d-flex justify-content-end">
                    <div className="card-footer">
                      <button
                        className="btn btn-color"
                        type="button"
                        onClick={() => handleEdit()}
                      >
                        {strings.update}
                      </button>
                    </div>
                  </div>
                  {!isEmpty(formVaild) && (
                    <div className="col-md-12 float-right">
                      <span
                        style={{
                          color: "red",
                          float: "right",
                          // padding: "5px 15px 25px 5px",
                        }}
                      >
                        {strings.fieldRequired}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EditAppointment;
